export const ONE_SEC_MS = 1000;
export const FIVE_SEC_MS = 5 * 1000;
export const TEN_SEC_MS = 10 * 1000;
export const THIRTY_SEC_MS = 30 * 1000;
export const ONE_MIN_MS = 60 * 1000;
export const FIFTEEN_MIN_MS = 15 * 60 * 1000;
